export const margin = { left: 50, right: 10, top: 10, bottom: 30 };
export const marginWithNarrowLeftAxis = { ...margin, left: 30 };
export const marginWithRightAxis = { ...margin, right: 50 };
export const marginWithRightAxisMobile = { ...margin, left: 10, right: 10 };
export const marginWithWideRightAxis = { ...margin, right: 50 };

const gridHeight = height => height - margin.top - margin.bottom;
const gridWidth = width => width - margin.left - margin.right;

export const yGrid = (width: number, isMobile?: boolean) => {
  return isMobile
    ? {}
    : {
        innerTickSize: -1 * gridWidth(width),
        tickStrokeDasharray: 'Solid',
        tickStrokeOpacity: 0.2,
        tickStrokeWidth: 1,
      };
};
export const xGrid = (height: number) => {
  return {
    innerTickSize: -1 * gridHeight(height),
    tickStrokeDasharray: 'Solid',
    tickStrokeOpacity: 0.05,
    tickStrokeWidth: 1,
  };
};
